export const COLUMN_ID = 'id';
export const COLUMN_PREVIEW = 'preview';
export const COLUMN_DETAILS = 'details';
export const COLUMN_STATUS = 'statusId';
export const COLUMN_START_DATE = 'startDate';
export const COLUMN_EXPIRATION_DATE = 'expirationDate';
export const COLUMN_COMMENTS = 'commentsCount';
export const COLUMN_USED_IN_ADS = 'hasStats';
export const COLUMN_TAGS = 'tags';
export const COLUMN_AI_TAGS = 'aiTags';
export const COLUMN_CONCEPT_FAMILIES = 'conceptFamilies';
export const COLUMN_RATING = 'rating';
export const COLUMN_REQUESTED_BY = 'requestedById';
export const COLUMN_DESIGNER = 'author';
export const COLUMN_BUSINESS_PARTNER = 'businessPartnerId';
export const COLUMN_EXCLUSIVE_FOR_AFFILIATES = 'exclusiveForAffiliates';
export const COLUMN_USED_IN_AFFILIATES = 'affiliates';
export const COLUMN_SHARED_WITH = 'sharedWith';
export const COLUMN_PROMO_CODE = 'promoCode';
export const COLUMN_CREATED_BY = 'createdById';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_UPDATED_DATE = 'updatedDate';
